import { render, staticRenderFns } from "./AntiSpamSettings.vue?vue&type=template&id=61870111&scoped=true"
import script from "./AntiSpamSettings.vue?vue&type=script&lang=js"
export * from "./AntiSpamSettings.vue?vue&type=script&lang=js"
import style0 from "./AntiSpamSettings.vue?vue&type=style&index=0&id=61870111&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61870111",
  null
  
)

export default component.exports